import { Component, OnDestroy, OnInit } from '@angular/core';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { CommonService } from "app/reusable/common.service";
import { environment } from "environments/environment";
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-claims-reserve-types-content',
  templateUrl: './claims-reserve-types-content.component.html',
  styleUrls: ['./claims-reserve-types-content.component.scss']
})
export class ClaimsReserveTypesContentComponent implements OnInit, OnDestroy {
  helpPlanTypesList=[];
  helpPlansList = [];
  claimsReserveTypesList = [];
  public expandMode: number = PanelBarExpandMode.Single;
  public AlphaURL : string = environment.Services.AlphaURL;
  private subject$ = new Subject(); 
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    let getHelpPlanTypesUrl: string = `HelpPlanType/GetClaimReserveByHelpPlanType`;
    let getHelpPlansUrl: string = `HelpPlan`;
    let helpPlanTypes$ = this.commonService.getData(getHelpPlanTypesUrl,  this.AlphaURL);
    let helpPlans$ = this.commonService.getData(getHelpPlansUrl,  this.AlphaURL);
    combineLatest(helpPlanTypes$, helpPlans$).pipe(takeUntil(this.subject$))
    .subscribe((results: any) => {
      this.helpPlanTypesList = results[0];
      this.helpPlansList = results[1];
    });
  }

  getClaimsReserveType(helpPlanType, helpPlan){
    let _claimsReserveType = null;
     this.helpPlanTypesList.forEach(el =>{
       if(el.htyName.trim() == helpPlanType.htyName.trim()){
        el.helpPlans.forEach(element => {
           if(element.hplName == helpPlan.hplName)
           _claimsReserveType = element.claimsReserveType;
         });
       }
     });
     return _claimsReserveType;
  }
  trackByKey(index,item){
    return item.key;
    }

  ngOnDestroy(): void { 
    this.subject$.next();
    this.subject$.complete();
  }
}